<template>
  <span id="change-shuttle-load-section" v-if="isVisible">
    <el-button id="btn-change-shuttle-load-select-unit" v-show="!outboundUnits.multiSelect && displayButton" type="success" plain @click="toggleMultiSelect()" size="mini">{{ $t('outbound.units.changeShuttleLoad') }}</el-button>
    <el-button id="btn-change-shuttle-load-cancel-select-unit" v-show="outboundUnits.multiSelect" type="default" @click="disableMultiSelect()" size="mini">{{ $t('common.cancel') }}</el-button>
    <el-button id="btn-change-shuttle-load" v-show="outboundUnits.multiSelect" type="primary" @click="handleOpen()" size="mini">{{ $t('outbound.units.changeShuttleLoad') }}</el-button>
    <el-dialog
      id="change-shuttle-load"
      width="35%"
      :title="$t('outbound.units.changeShuttleLoad')"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
    >
      <el-form
        :model="changeShuttleLoadForm"
        :rules="formRules"
        ref="changeShuttleLoadForm"
        label-position="top"
        size="mini"
      >
        <el-row :gutter="10">
          <el-col>
            <span>{{ $t('outbound.units.totalUnitsShuttleLoad') }} <b>{{ outboundUnits.total }}</b></span>
          </el-col>
        </el-row>

        <el-row :gutter="10" class="margin-t-4">
          <el-col class="form-vertical-item">
            <el-form-item :label="$t('outbound.units.shuttleLoad')" prop="shuttleLoadId">
              <el-select
                v-model="changeShuttleLoadForm.shuttleLoadId"
                filterable
                remote
                reserve-keyword
                :remote-method="searchAvailableShuttleLoad"
                :loading="loadingShuttleLoad"
                ref="shuttleLoadIdSelect"
              >
                <el-option
                  v-for="shuttleLoad in availableShuttleLoad"
                  :key="shuttleLoad.id"
                  :label="shuttleLoad.number"
                  :value="shuttleLoad.id"
                ></el-option>
                </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div
        id="change-shuttle-load-dialog-footer"
        slot="footer"
        class="dialog-footer form-vertical-item flex-reverse-direction"
      >
        <el-button
          type="primary"
          id="change-shuttle-load-submit-button"
          @click="submitForm()"
          size="mini"
        >{{ $t('outbound.units.changeShuttleLoad') }}</el-button>
        <el-button
          id="change-shuttle-load-clear-button"
          @click="resetForm()"
          size="mini"
        >{{ $t('common.clear') }}</el-button>
      </div>
    </el-dialog>
  </span>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { Message } from 'element-ui';
import {
  OUTBOUND_SHUTTLE_LOAD_AUTOCOMPLETE,
  OUTBOUND_UNITS_CHANGE_SHUTTLE_LOAD,
  OUTBOUND_UNITS_DISABLE_MULTI_SELECT,
  OUTBOUND_UNITS_ENABLE_MULTI_SELECT,
  OUTBOUND_UNITS_SEARCH
} from '@/store/actions';
import constants from '@/utils/constants';

export default {
  name: 'ChangeShuttleLoadDialog',
  props: {
    displayButton: Boolean,
  },
  computed: {
    ...mapGetters([
      'outboundUnits',
    ]),
  },
  data() {
    return {
      dialogVisible: false,
      loadingShuttleLoad: false,
      availableShuttleLoad: [],
      changeShuttleLoadForm: {
        shuttleLoadId: null,
      },
      formRules: {
        shuttleLoadId: [
          { required: true, message: this.$t('outbound.units.error.shuttleLoadRequired'), trigger: 'submit' }
        ],
      },
    };
  },
  methods: {
    ...mapActions({
      autocompleteShuttleLoad: OUTBOUND_SHUTTLE_LOAD_AUTOCOMPLETE,
      changeShuttleLoad: OUTBOUND_UNITS_CHANGE_SHUTTLE_LOAD,
      searchUnits: OUTBOUND_UNITS_SEARCH,
      enableMultiSelect: OUTBOUND_UNITS_ENABLE_MULTI_SELECT,
      disableMultiSelect: OUTBOUND_UNITS_DISABLE_MULTI_SELECT
    }),
    isVisible() {
      return this.outboundUnits.list && this.outboundUnits.list.length > 0;
    },
    toggleMultiSelect() {
      if (!this.outboundUnits.actualFilters.shuttleNumber
        || this.outboundUnits.actualFilters.shuttleNumber.trim() === '') {
        this.$message.warning(this.$t('outbound.units.error.shuttleLoadFilterRequired'));
        return;
      }

      this.enableMultiSelect();
    },
    handleOpen() {
      if (this.outboundUnits.selectedUnits.length === 0) {
        this.$message.warning(this.$t('outbound.units.error.unitSelectedRequired'));
        return;
      }

      this.dialogVisible = true;
      this.$nextTick(() => {
        this.resetForm();
      });
    },
    searchAvailableShuttleLoad(query) {
      if (query && query.length >= 2 && query.trim()) {
        this.loadingShuttleLoad = true;

        const filter = {
          number: query.trim(),
          previousShuttleLoadId: this.isVisible ? this.outboundUnits.list[0].shuttleLoadId : undefined,
        };
        this.autocompleteShuttleLoad(filter)
          .then((response) => {
            this.availableShuttleLoad = response.data;
          })
          .finally(() => {
            this.loadingShuttleLoad = false;
          });
      }
    },
    submitForm() {
      const data = {
        shuttleLoadId: this.changeShuttleLoadForm.shuttleLoadId,
        filterUnitDto: this.outboundUnits.actualFilters,
        selectAll: this.outboundUnits.selectedUnits.length === this.outboundUnits.list.length,
        unitIdList: this.outboundUnits.selectedUnits.map(unit => unit.id)
      };
      this.$refs.changeShuttleLoadForm.validate((valid) => {
        if (valid) {
          Message.closeAll();
          const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
          this.changeShuttleLoad(data)
            .then((response) => {
              this.$message.success(response.message);
              this.disableMultiSelect();
              this.searchUnits({});
              this.dialogVisible = false;
            })
            .finally(() => loading.close());
        }
      });
    },
    resetForm() {
      this.changeShuttleLoadForm.shuttleLoadId = null;
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
#change-shuttle-load-section {
  text-align: left;

  #btn-change-shuttle-load-select-unit {
    margin-right: 10px;
  }
}
</style>
